import { useCallback, useEffect, useState } from "react";
import loadStore from "@/utils/generateStore";
import { PrinterConfig } from "@/types/printer";

const PRINTER_CONFIG_KEY = "printerConfig";

function usePrinterConfig() {
  const [config, setConfig] = useState<PrinterConfig | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    loadStore()
      .then(async (store) => {
        const saved = await store.get(PRINTER_CONFIG_KEY);
        if (saved) {
          try {
            setConfig(JSON.parse(saved) as PrinterConfig);
          } catch {
            // Stored value is corrupt — ignore and start fresh.
          }
        }
        setIsLoaded(true);
      })
      .catch(() => {
        setIsLoaded(true);
      });
  }, []);

  const save = useCallback(async (newConfig: PrinterConfig) => {
    const store = await loadStore();
    await store.set(PRINTER_CONFIG_KEY, JSON.stringify(newConfig));
    setConfig(newConfig);
  }, []);

  const clear = useCallback(async () => {
    const store = await loadStore();
    await store.delete(PRINTER_CONFIG_KEY);
    setConfig(null);
  }, []);

  return { config, isLoaded, save, clear };
}

export default usePrinterConfig;
